import React, { useState, useEffect } from 'react';
import { useNavigate, Route, Routes, useLocation } from 'react-router-dom';
import './index.css';
import { Layout, Menu, Image, Space, Form, Typography } from 'antd';
import { Notifications, UserDropdown } from '../components/Header';
import { JobSingleView, ProtrackSingleView, SingleViewClient, SingleViewNotification, SingleViewPro } from '../components';
import { Dashboard } from './Dashboard';
import { Clients } from './Clients';
import { ProfessionalPage } from './ProfessionalPage';
import { Jobspage } from './Jobpage';
import { ProjectTracking } from './ProjectTracking';
import { Notificationpage } from './Notificationpage';
import { MessageBox } from './MessageBox';
import { ReviewPage } from './ReviewPage';
import { PaymentPage } from './PaymentPage';
import { Faq } from './Faq';
import { ServicePage } from './ServicePage';
import { Transaction } from './Transaction';
import { Settings } from './Settings';

const { Header, Sider, Content } = Layout;
const RouteF = () => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [items, setItems] = useState([]);
  const [currentTab, setCurrentTab] = useState('1');
  const [openKeys, setOpenKeys] = useState(['']);
  

  function getItem(label, key, icon, children) {
    return { key, icon, children, label };
  }

  useEffect(() => {
    let tab = location?.pathname?.split("/")[1];
    tab = tab === '' ? '1' :
          tab === 'clients' ? '2' :
          tab === 'professional' ? '3' :
          tab === 'job' ? '4' :
          tab === 'protrack' ? '5' :
          tab === 'service' ? '6' :
          tab === 'notification' ? '7' :
          tab === 'chat' ? '8' :
          tab === 'review' ? '9' :
          tab === 'paymentDetail' ? '10' :
          tab === 'transaction' ? '11' :
          tab === 'faq' ? '12' :
          tab === 'setting' ? '13' :
      '1';
    setCurrentTab(tab);
  }, [location]);

  useEffect(() => {
    let itemsArr = [
      getItem('Dashboard', '1',
      currentTab === '1' ? 
      <img src="/assets/icons/dash-w.png" width={'15px'} alt="" /> :
      <img src="/assets/icons/dash-b.png" width={'15px'} alt="" />
    ),
      getItem('Clients', '2', 
        currentTab === '2' ? 
        <img src="/assets/icons/clients-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/clients-b.png" width={'18px'} alt="" />
      ),
      getItem('Professional', '3', 
        currentTab === '3' ? 
        <img src="/assets/icons/prof-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/prof-d.png" width={'18px'} alt="" />
      ),
      getItem('Jobs', '4',
        currentTab === '4' ? 
        <img src="/assets/icons/job-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/job-b.png" width={'18px'} alt="" />  
      ),
      getItem('Project Tracking', '5',
        currentTab === '5' ? 
        <img src="/assets/icons/protrack-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/protrack-b.png" width={'18px'} alt="" />  
      ),
      getItem('Service', '6',
        currentTab === '6' ? 
        <img src="/assets/icons/service-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/service-b.png" width={'18px'} alt="" />  
      ),
      getItem('Notification', '7',
        currentTab === '7' ? 
        <img src="/assets/icons/noti-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/noti-b.png" width={'18px'} alt="" />  
      ),
      getItem('Chat', '8',
        currentTab === '8' ? 
        <img src="/assets/icons/chat-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/chat-b.png" width={'18px'} alt="" />  
      ),
      getItem('Reviews', '9',
        currentTab === '9' ? 
        <img src="/assets/icons/review-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/review-b.png" width={'18px'} alt="" />  
      ),
      getItem('Payment Details', '10',
        currentTab === '10' ? 
        <img src="/assets/icons/pay-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/pay-b.png" width={'18px'} alt="" />  
      ),
      getItem('Transaction History', '11',
        currentTab === '11' ? 
        <img src="/assets/icons/t-history-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/t-history-b.png" width={'18px'} alt="" />  
      ),
      getItem('Faqs', '12',
        currentTab === '12' ? 
        <img src="/assets/icons/faq-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/faq-b.png" width={'18px'} alt="" />  
      ),
      getItem('Settings', '13',
        currentTab === '13' ? 
        <img src="/assets/icons/settings-w.png" width={'18px'} alt="" /> :
        <img src="/assets/icons/settings-b.png" width={'18px'} alt="" />  
      ),
    ];

    setItems([...itemsArr]);
  }, [currentTab]);


  const handleMenuClick = (e) => {
    const { key } = e;
    switch (key) {
      case '1':
        navigate("/", { replace: true });
        break;
      case '2':
        navigate("/clients", { replace: true });
        break;
      case '3':
        navigate("/professional", { replace: true });
        break;
      case '4':
        navigate("/job", { replace: true });
        break;
      case '5':
        navigate("/protrack", { replace: true });
        break;
      case '6':
        navigate("/service", { replace: true });
        break;
      case '7':
        navigate("/notification", { replace: true });
        break;
      case '8':
        navigate("/chat", { replace: true });
        break;
      case '9':
        navigate("/review", { replace: true });
        break;
      case '10':
        navigate("/paymentDetail", { replace: true });
        break;
      case '11':
        navigate("/transaction", { replace: true });
        break;
      case '12':
        navigate("/faq", { replace: true });
        break;
      case '13':
        navigate("/setting", { replace: true });
        break;
      default:
        break;
    }
  };

 
  const onOpenChange = (keys) => {
    setOpenKeys(keys);
    // localStorage.setItem('openKeys', JSON.stringify(keys));
  };
  return (
    <Layout style={{ height: '100vh' }}>
      <Sider breakpoint="md"
        collapsedWidth="80"
        onBreakpoint={(broken) => {
          setCollapsed(broken)
        }} trigger={null} collapsible collapsed={collapsed} className={collapsed ? 'addclass' :''} style={{ height: '100vh', overflowY: 'auto',borderRight:'1px solid #E3E3E3'}}>
        <div className="logo" style={{ display: 'flex', justifyContent: 'center' }}>
          <Image
            style={{ width: collapsed ? "100%" : '150px' }}
            height={'auto'}
            src="/assets/images/logo.png"
            alt='Jsan Admin Panel'
            preview={false}
          />
        </div>
        <Menu
          defaultSelectedKeys={['1']}
          selectedKeys={[currentTab]}
          mode="inline"
          theme="dark"
          onClick={handleMenuClick}
          onOpenChange={onOpenChange}
          openKeys={openKeys}
          items={items}
          className={collapsed ? 'addmenu' :'listitem'}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background header-mbl-cs shadow-d"
          style={{
            padding: 0,
            display: 'flex',
            paddingLeft:0,
            justifyContent: 'center'
          }}
        >
          <div style={{ width: '98%', display: 'flex', justifyContent: 'space-between',alignItems:'center',position:'relative',gap:5, }}>
            <Space className='w-100 mbl-space'>
              <div className='trigger' onClick={() => setCollapsed(!collapsed)}>
                <Image src='/assets/icons/collapse.png' 
                  width={'35px'} preview={false} 
                  style={{transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)'}}  
                />
              </div>
              {/* <Image src='/assets/icons/stars-t.png' 
                width={'25px'} preview={false} 
              /> */}
              <Typography.Title className='m-0 fw-500' level={5}>
                Welcome to Admin Panel!
              </Typography.Title>
            </Space>
            <Space size={15}>
              <Notifications />
              <UserDropdown />
            </Space>
          </div>
        </Header>
        
        <Content
          className="scroll-bar"
          style={{
            margin: '24px 10px',
            padding: '0 15px',
            minHeight: 280,
            overflowY: 'auto',
          }}
        >
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/detail/:clientId" element={<SingleViewClient />} />
            <Route path="/professional" element={<ProfessionalPage />} />
            <Route path="/professional/detail/:proId" element={<SingleViewPro />} />
            <Route path="/job" element={<Jobspage />} />
            <Route path="/job/detail/:jobId" element={<JobSingleView />} />
            <Route path="/protrack" element={<ProjectTracking />} />
            <Route path="/protrack/detail/:trackId" element={<ProtrackSingleView />} />
            <Route path="/notification" element={<Notificationpage />} />
            <Route path="/notification/detail/:notiId" element={<SingleViewNotification />} />
            <Route path="/chat" element={<MessageBox />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/paymentDetail" element={<PaymentPage />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/setting" element={<Settings />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default RouteF;
